import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = {
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
  failedInvitations: [],
};

function handleRequest(state: State): State {
  return { ...state, request: setRequestStateToPending() };
}

function handleSuccess(state: State): State {
  return {
    ...state,
    request: setRequestStateToSuccess(),
    failedInvitations: [],
  };
}

function handleFailure(
  state: State,
  { failedInvitations }: Boundaries["inviteMembers"]["failure"],
): State {
  return {
    ...state,
    request: setRequestStateToFailure(),
    failedInvitations: [...state.failedInvitations, ...failedInvitations],
  };
}

function handleLogOut(): State {
  return initialState;
}

const reduceState = createStateReducer(initialState, {
  [events.inviteMembersRequested]: handleRequest,
  [events.inviteMembersSucceeded]: handleSuccess,
  [events.inviteMembersFailed]: handleFailure,
  [events.logOutSucceeded]: handleLogOut,
});

export type { State, Selector };

export { reduceState, initialState, createSelector };
